import { render } from "./IntegrationConfigModal.vue?vue&type=template&id=92d69860"
import script from "./IntegrationConfigModal.vue?vue&type=script&lang=ts"
export * from "./IntegrationConfigModal.vue?vue&type=script&lang=ts"

import "./IntegrationConfigModal.vue?vue&type=style&index=0&id=92d69860&lang=scss"
script.render = render

export default script